import initClient from 'edusystem-api-client'
import {apiDomain, apiHost, apiProtocol} from 'settings'

const server = `${apiHost}.${apiDomain}`
const request = initClient({server, protocol: apiProtocol})

export const createPost = (context, command, options) => request(context, command, {...options, method: 'POST'})

export {request as default}
